const DEMOCRAT = '#2569C4';
const DEMOCRAT_LEAN = '#6DACD3'
const REPUBLICAN = '#EF564A';
const REPUBLICAN_LEAN = '#F6A79D';
const LIBERTARIAN = '#1a2b4b';
const GREEN = '#3cc687';
const INDEPENDENT = '#8790A0';


const OTHER = '#888888';

const NEUTRAL = '#F2F2F2';
const TIE = '#999999';

export {
  DEMOCRAT,
  DEMOCRAT_LEAN,
  REPUBLICAN_LEAN,
  REPUBLICAN,
  LIBERTARIAN,
  GREEN,
  INDEPENDENT,
  NEUTRAL,
  TIE,
  OTHER,
};
